{
  "dismiss": "Rejeter"
}